export const UPDATE_CHANNELS = 'UPDATE_CHANNELS';
export const UPDATE_AUTH = 'UPDATE_AUTH';

export const onUpdateAuth = (bool) => (
  { type: UPDATE_AUTH, isAuthenticated: bool }
)

export const onUpdateChannels = (res) => (
  { type: UPDATE_CHANNELS, channels: res }
)